module.exports = __webpack_public_path__ + "static/PastoralCare2-e8e67c03937f6b20784cd3052e37f3fe.jpg";